import asyncComponent from 'util/AsyncComponent';

import {SHOW_MOCKS} from 'config';
import {PERIOD_TYPES} from 'config/constants/period';

import {invalidateDashboard} from 'modules/dashboard';
import {invalidateInfrastructureResources} from 'modules/infrastructureResources';
// import {invalidateAwsReservations} from 'modules/awsReservations';
import {invalidateReportsUI} from 'modules/reportsUI';
import {invalidateAwsTickets} from 'modules/awsTickets';
import {invalidateMyCredentials} from 'modules/userCredentials';
import {invalidateMyAccounts} from 'modules/userAccounts';
import {invalidateReportP200} from 'modules/reportP200';
import {invalidateBackupsSummary, invalidateBackupsReport} from 'modules/backups';
import {invalidateBillingAlertsTable} from 'modules/alertsForm';
import {invalidateCloudBillingExplorer, invalidateCloudBillingBreakdown} from 'modules/cloudBilling';
import {invalidateMonitoring, invalidateEventsTable} from 'modules/monitoring';
import {invalidateStorage} from 'modules/storage';
import {invalidateCMDB} from 'modules/cmdb';


import Login from 'routes/Login';
// import Dashboard from 'routes/dashboard/Dashboard';
import RecoverPassword from 'routes/RecoverPassword';
import ResetPassword from 'routes/reset/ResetPassword';
const IPSGlobalInformationRoute = asyncComponent(() => import('routes/iaas/IPSGlobalInformationRoute'));
const IPSResourcesRoute = asyncComponent(() => import('routes/iaas/IPSResourcesRoute'));
const IPSVCenterRoute = asyncComponent(() => import('routes/iaas/IPSVCenterRoute'));
const ITSMOpenTicketsRoute = asyncComponent(() => import('routes/itsm/ITSMOpenTicketsRoute'));
const ITSMSummaryTicketsRoute = asyncComponent(() => import('routes/itsm/ITSMSummaryTicketsRoute'));
const ITSMDetailsRoute = asyncComponent(() => import('routes/itsm/ITSMDetailsRoute'));
const InfrastructureResourcesRoute = asyncComponent(() => import('routes/infrastructure/InfrastructureResourcesRoute'));
const InfrastructureResourceShowRoute = asyncComponent(() => import('routes/infrastructure/InfrastructureResourceShowRoute'));
// const InfrastructureReservationsRoute = asyncComponent(() => import('routes/infrastructure/InfrastructureReservationsRoute'));
const BillingAlertsRoute = asyncComponent(() => import('routes/alerts/BillingAlertsRoute'));
const BillingAlertsEdit = asyncComponent(() => import('routes/alerts/BillingAlertsEdit'));
const BillingAlertsNew = asyncComponent(() => import('routes/alerts/BillingAlertsNew'));
const MonitoringActiveEventsRoute = asyncComponent(() => import('routes/monitoring/MonitoringActiveEventsRoute'));
const MonitoringAllEventsRoute = asyncComponent(() => import('routes/monitoring/MonitoringAllEventsRoute'));
const MonitoringDetailEventsRoute = asyncComponent(() => import('routes/monitoring/MonitoringDetailEventsRoute'));
const ConsultancyAwsRoute = asyncComponent(() => import('routes/consultancy/ConsultancyAwsRoute'));
const ConsultancyAwsShow = asyncComponent(() => import('routes/consultancy/ConsultancyAwsShow'));
const ConsultancyAwsNew = asyncComponent(() => import('routes/consultancy/ConsultancyAwsNew'));
const ReportsByVendor = asyncComponent(() => import('routes/report/ReportsByVendor'));
const CloudBilling = asyncComponent(() => import('routes/report/CloudBilling'));
const CloudBillingBreakdown = asyncComponent(() => import('routes/cloud-billing/CloudBillingBreakdown'));
const ReportsByCostCenter = asyncComponent(() => import('routes/report/ReportsByCostCenter'));
const ReportsSummary = asyncComponent(() => import('routes/report/ReportsSummary'));
const UserProfile = asyncComponent(() => import('routes/user/UserProfile'));
const UserAccountsRoute = asyncComponent(() => import('routes/user/UserAccountsRoute'));
const UserAccountsEdit = asyncComponent(() => import('routes/user/UserAccountsEdit'));
const UserCredentialsRoute = asyncComponent(() => import('routes/user/UserCredentialsRoute'));
const CredentialsEditRoute = asyncComponent(() => import('routes/credentials/CredentialsEditRoute'));
const CredentialsNewRoute = asyncComponent(() => import('routes/credentials/CredentialsNewRoute'));
const Plans = asyncComponent(() => import('routes/jobplans/Plans'));
const PlanNew = asyncComponent(() => import('routes/jobplans/PlanNew'));
const Contacts = asyncComponent(() => import('routes/csc/Contacts'));
const ContactNew = asyncComponent(() => import('routes/csc/ContactNew'));
const ContactShow = asyncComponent(() => import('routes/csc/ContactShow'));
const ContactEdit = asyncComponent(() => import('routes/csc/ContactEdit'));
const BackupsMocks = asyncComponent(() => import('routes/backups/BackupsMocks'));
const Backups = asyncComponent(() => import('routes/backups/Backups'));
const BackupsReportRoute = asyncComponent(() => import('routes/backups/BackupsReportRoute'));
const P200Report = asyncComponent(() => import('routes/p200/P200Report'));
const Portals = asyncComponent(() => import('routes/portals/Portals'));
const CustomerVoice = asyncComponent(() => import('routes/customer-voice/CustomerVoice'));
const ImpersonateRoute = asyncComponent(() => import('routes/impersonate/ImpersonateRoute'));
const AzureRefreshToken = asyncComponent(() => import('routes/azure-refresh-token/AzureRefreshToken'));
const StorageNASRoute = asyncComponent(() => import('routes/storage/StorageNASRoute'));
const StorageSANRoute = asyncComponent(() => import('routes/storage/StorageSANRoute'));
const StorageObjectsRoute = asyncComponent(() => import('routes/storage/StorageObjectsRoute'));
const StorageDetailRoute = asyncComponent(() => import('routes/storage/StorageDetailRoute'));
const CMDBGlobalRoute = asyncComponent(() => import('routes/cmdb/CMDBGlobalRoute'));
const CMDBDetailsRoute = asyncComponent(() => import('routes/cmdb/CMDBDetailsRoute'));

const impersonate = [{
    name: 'title.impersonate',
    path: 'impersonate'
}];

const cloud = [{
    clave:      'cloud',
    breadcrumb: 'title.dashboard',
    name:       'title.dashboard',
    path:       'cloud'
},{
    name: 'title.reports',
    path: 'reports/resume'
},{
    name: 'title.billing_alerts',
    path: 'billing-alerts/alerts'
},{
    name: 'title.resources',
    path: 'infrastructure/resources'
},{
    name: 'title.aws_support',
    path: 'consultancy/aws'
}];

// const dashboard = [{
//     clave: 'cloud',
//     breadcrumb: 'true',
//     name: 'title.dashboard',
//     path: 'dashboard'
// }];

const billing = [
    {
        clave:      'cloud',
        breadcrumb: 'title.reports',
        name:       'cloudBillingTitleResume',
        path:       'reports/resume'
    },
    {
        name: 'spendingBreakdown',
        path: 'reports/spending-breakdown',
        sup:  'Beta'
    },
    {
        name: 'title.by_account',
        path: 'reports/by-account'
    },{
        name: 'title.by_vendor',
        path: 'reports/by-vendor'
    },{
        name: 'title.by_cost_center',
        path: 'reports/by-cost-center'
    }
];

const billingAlerts = [{
    clave:      'cloud',
    breadcrumb: 'title.alerts',
    name:       'title.billing_alerts',
    path:       'billing-alerts/alerts'
}];

const consultancy = [{
    clave:      'cloud',
    breadcrumb: 'title.aws_support',
    name:       'title.aws_support',
    path:       'consultancy/aws'
}];

const iaas = [{
    name: 'title.global_information',
    path: 'ips/global-information'
},
{
    name: 'title.ips_vcloud',
    path: 'ips/dedicated-hosts'
},
{
    name: 'title.ips_vcenter',
    path: 'ips/vcenter-resources'
}];

const itsm = [{
    name: 'title.itsm_active_tickets',
    path: 'itsm/open-tickets'
},
{
    name: 'title.itsm_all_tickets',
    path: 'itsm/all-tickets'
},
{
    name: 'title.itsm_details',
    path: 'itsm/details'
}];

const infrastructure = [{
    clave:      'cloud',
    breadcrumb: 'title.resources',
    name:       'title.resources',
    path:       'infrastructure/resources'
},{
    name: 'title.reservations',
    path: 'infrastructure/reservations'
}];

const monitoring = [
    {
        name: 'title.ActiveEvents',
        path: 'monitoring/active-events'
    },
    {
        name: 'title.AllEvents',
        path: 'monitoring/all-events'
    },
    {
        name: 'title.DetailEvents',
        path: 'monitoring/detail-events'
    }
];

const storage = [
    {
        name: 'title.storage.NAS',
        path: 'storage/nas'
    },
    {
        name: 'title.storage.SAN',
        path: 'storage/san'
    },
    {
        name: 'title.storage.objects',
        path: 'storage/objects'
    },
    {
        name: 'title.storage.detail',
        path: 'storage/detail'
    }
];

const cmdb = [
    {
        name: 'title.cmdb.tab.globalCMDBInformation',
        path: 'cmdb/global-chart'
    },
    {
        name: 'title.cmdb.tab.CMDBDetails',
        path: 'cmdb/details'
    },
    {
        name: 'title.p200.report',
        path: 'p200/report'
    }
];

const user = [{
    name: 'title.my_profile',
    path: 'my/profile'
}
//  {
//     name: 'title.my_accounts',
//     path: 'my/accounts'
// },
// {
//     name: 'title.my_security_credentials',
//     path: 'my/credentials'
// }
];
const jobplans = [{
    name: 'title.plans',
    path: 'jobplans/plans'
}];
const csc = [{
    name: 'title.contacts',
    path: 'csc/contacts'
}];
const backups = [{
    name: 'title.summary',
    path: 'backups/summary'
},{
    name: 'title.report',
    path: 'backups/report'
}];
const backupsMocks = [{
    name: 'title.backups',
    path: 'backups_mocks'
}];
// const p200 = [{
//     name: 'title.p200.report',
//     path: 'p200/report'
// }];
const portals = [{
    name: 'label.otherPortals',
    path: 'external-portals'
}];

const customerVoice = [{
    name: 'label.customerVoice',
    path: 'customer-voice'
}];

// NO ICON ON EXTRA MEANS IT WILL NOT BE SHOWN IN THE SIDEBAR.
// isExternal, will prevent the navigation to be shown.
const routes = [{
    path:       '/login',
    component:  Login,
    isExternal: true
},{
    path:       '/recover-password/:uid/:recoveryKey',
    component:  RecoverPassword,
    isExternal: true
},{
    path:       '/recover-password/',
    component:  RecoverPassword,
    isExternal: true
},{
    path:       '/reset-password',
    component:  ResetPassword,
    isExternal: true
}, {
    path:          '/impersonate',
    component:     ImpersonateRoute,
    private:       true,
    extra:         {icon: 'user', name: 'title.impersonate'},
    navNodes:      impersonate,
    onlyInternals: true
},
{
    path:     '/',
    redirect: '/ips/global-information'
},
{
    path:     '/reports/',
    redirect: '/reports/summary'
},{
    path:     '/infrastructure/',
    redirect: '/infrastructure/resources'
}, {
    path:     '/backups/',
    redirect: '/backups/summary'
}, {
    path:     '/consultancy/',
    redirect: '/consultancy/aws'
}, {
    path:     '/jobplans/',
    redirect: '/jobplans/plans'
},{
    path:     '/my/',
    redirect: '/my/profile'
},
{
    path:         '/ips/global-information',
    component:    IPSGlobalInformationRoute,
    private:      true,
    extra:        {icon: 'iaas', name: 'title.ips_platform', service: 'iaas'},
    navNodes:     iaas,
    dateRequired: {
        section: 'iaas',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateDashboard,
    requiredServices: ['iaas']
},
{
    path:         '/ips/dedicated-hosts',
    component:    IPSResourcesRoute,
    private:      true,
    extra:        {name: 'title.dedicated_hosts', service: 'iaas'},
    sidebarPath:  '/ips/global-information',
    navNodes:     iaas,
    dateRequired: {
        section: 'iaas',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateDashboard,
    requiredServices: ['iaas']
},
{
    path:         '/ips/vcenter-resources',
    component:    IPSVCenterRoute,
    private:      true,
    extra:        {name: 'title.dedicated_hosts', service: 'iaas'},
    sidebarPath:  '/ips/global-information',
    navNodes:     iaas,
    dateRequired: {
        section: 'iaas',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateDashboard,
    requiredServices: ['iaas']
},
{
    path:             '/itsm/open-tickets',
    component:        ITSMOpenTicketsRoute,
    private:          true,
    extra:            {name: 'title.itsm', service: 'itsm'},
    sidebarPath:      '/itsm/all-tickets',
    navNodes:         itsm,
    refresh:          invalidateDashboard,
    requiredServices: ['tickets']
},
{
    path:         '/itsm/all-tickets',
    component:    ITSMSummaryTicketsRoute,
    private:      true,
    extra:        {icon: 'itsm', name: 'title.itsm', service: 'itsm'},
    navNodes:     itsm,
    dateRequired: {
        section: 'itsm',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateDashboard,
    requiredServices: ['tickets']
},
{
    path:         '/itsm/details',
    component:    ITSMDetailsRoute,
    private:      true,
    extra:        {name: 'title.itsm', service: 'itsm'},
    sidebarPath:  '/itsm/all-tickets',
    navNodes:     itsm,
    dateRequired: {
        section: 'itsm',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateDashboard,
    requiredServices: ['tickets']
},
{
    path:         '/storage/nas',
    component:    StorageNASRoute,
    private:      true,
    extra:        {icon: 'storage',name: 'title.storagePlatform', service: 'storage'},
    sidebarPath:  '/storage/nas',
    navNodes:     storage,
    dateRequired: {
        section: 'storage',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateStorage,
    requiredServices: ['storage']
},
{
    path:         '/storage/san',
    component:    StorageSANRoute,
    private:      true,
    extra:        {name: 'title.events', service: 'storage'},
    sidebarPath:  '/storage/nas',
    navNodes:     storage,
    dateRequired: {
        section: 'storage',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateStorage,
    requiredServices: ['storage']
},
{
    path:         '/storage/objects',
    component:    StorageObjectsRoute,
    private:      true,
    extra:        {name: 'title.events', service: 'storage'},
    sidebarPath:  '/storage/nas',
    navNodes:     storage,
    dateRequired: {
        section: 'storage',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateStorage,
    requiredServices: ['storage']
},
{
    path:         '/storage/detail',
    component:    StorageDetailRoute,
    private:      true,
    extra:        {name: 'title.events', service: 'storage'},
    sidebarPath:  '/storage/nas',
    navNodes:     storage,
    dateRequired: {
        section: 'storage',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateStorage,
    requiredServices: ['storage']
},
{
    path:         '/backups/report',
    component:    BackupsReportRoute,
    private:      true,
    sidebarPath:  '/backups/summary',
    extra:        {name: 'title.backupPlatform', service: 'backups'},
    navNodes:     backups,
    dateRequired: {
        section: 'backups',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateBackupsReport,
    requiredServices: ['backups']
},
{
    path:         '/backups/summary',
    component:    Backups,
    private:      true,
    sidebarPath:  '/backups/summary',
    extra:        {icon: 'backup',name: 'title.backups', service: 'backups'},
    navNodes:     backups,
    dateRequired: {
        section: 'backups',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateBackupsSummary,
    requiredServices: ['backups']
},
{
    path:             '/monitoring/active-events',
    component:        MonitoringActiveEventsRoute,
    private:          true,
    extra:            {icon: 'monitoring',name: 'title.monitoringPlatform', service: 'monitoring'},
    sidebarPath:      '/monitoring/active-events',
    navNodes:         monitoring,
    refresh:          invalidateMonitoring,
    requiredServices: ['monitoring']
},
{
    path:         '/monitoring/all-events',
    component:    MonitoringAllEventsRoute,
    private:      true,
    extra:        {name: 'title.AllEvents', service: 'monitoring'},
    sidebarPath:  '/monitoring/active-events',
    navNodes:     monitoring,
    dateRequired: {
        section: 'monitoring',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateMonitoring,
    requiredServices: ['monitoring']
},
{
    path:         '/monitoring/detail-events',
    component:    MonitoringDetailEventsRoute,
    private:      true,
    extra:        {name: 'title.events', service: 'monitoring'},
    sidebarPath:  '/monitoring/active-events',
    navNodes:     monitoring,
    dateRequired: {
        section: 'monitoring',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateEventsTable,
    requiredServices: ['monitoring']
},
// {
//     path:         '/cloud/',
//     component:    Dashboard,
//     private:      true,
//     sidebarPath:  '/cloud/',
//     extra:        {icon: 'cloud', name: 'title.cloud', service: 'publicCloud'},
//     navNodes:     cloud,
//     dateRequired: {
//         section: 'dashboard',
//         types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
//     },
//     refresh:          invalidateDashboard,
//     requiredServices: ['publicCloud']
// },
{
    path:         '/reports/resume',
    component:    CloudBilling,
    private:      true,
    sidebarPath:  '/cloud/',
    extra:        {name: 'title.monitoringPlatform', service: 'publicCloud'},
    navNodes:     billing,
    dateRequired: {
        section: 'cloudBilling',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateCloudBillingExplorer,
    requiredServices: ['publicCloud']
},
{
    path:             '/reports/by-account',
    component:        ReportsSummary,
    extra:            {name: 'title.reports', service: 'publicCloud'},
    private:          true,
    sidebarPath:      '/cloud/',
    navNodes:         billing,
    dateRequired:     'reports',
    refresh:          invalidateReportsUI,
    requiredServices: ['publicCloud']
},
{
    path:             '/reports/by-vendor',
    component:        ReportsByVendor,
    extra:            {name: 'title.by_vendor', service: 'publicCloud'},
    private:          true,
    sidebarPath:      '/cloud/',
    navNodes:         billing,
    dateRequired:     'reports',
    refresh:          invalidateReportsUI,
    requiredServices: ['publicCloud']
},
{
    path:             '/reports/by-cost-center',
    component:        ReportsByCostCenter,
    private:          true,
    extra:            {name: 'title.by_cost_center', service: 'publicCloud'},
    sidebarPath:      '/cloud/',
    navNodes:         billing,
    dateRequired:     'reports',
    refresh:          invalidateReportsUI,
    requiredServices: ['publicCloud']
},
{
    path:         '/reports/spending-breakdown',
    component:    CloudBillingBreakdown,
    private:      true,
    extra:        {name: 'title.mock', service: 'publicCloud'},
    sidebarPath:  '/cloud/',
    navNodes:     billing,
    dateRequired: {
        section: 'cloudBilling',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateCloudBillingBreakdown,
    requiredServices: ['publicCloud']
},
{
    path:             '/billing-alerts/alerts/:alertId/show',
    component:        BillingAlertsEdit,
    private:          true,
    navNodes:         cloud,
    sidebarPath:      '/cloud/',
    extra:            {name: 'title.edit_billingAlert', service: 'publicCloud'},
    requiredServices: ['publicCloud']
},
{
    path:             '/consultancy/aws',
    component:        ConsultancyAwsRoute,
    sidebarPath:      '/cloud/',
    extra:            {name: 'title.aws_support', service: 'publicCloud'},
    private:          true,
    navNodes:         consultancy,
    refresh:          invalidateAwsTickets,
    requiredServices: ['publicCloud']
},
{
    path:             '/consultancy/aws/new',
    component:        ConsultancyAwsNew,
    extra:            {service: 'publicCloud'},
    private:          true,
    sidebarPath:      '/consultancy/aws',
    navNodes:         consultancy,
    requiredServices: ['publicCloud']
},
{
    path:             '/consultancy/aws/:accountId/:ticketId/show',
    component:        ConsultancyAwsShow,
    private:          true,
    extra:            {service: 'publicCloud'},
    sidebarPath:      '/consultancy/aws',
    navNodes:         consultancy,
    refresh:          invalidateAwsTickets,
    requiredServices: ['publicCloud']
},
{
    path:             '/billing-alerts/alerts',
    component:        BillingAlertsRoute,
    private:          true,
    extra:            {name: 'title.billing_alerts', service: 'publicCloud'},
    navNodes:         billingAlerts,
    sidebarPath:      '/cloud/',
    refresh:          invalidateBillingAlertsTable,
    requiredServices: ['publicCloud']
},
{
    path:             '/billing-alerts/alerts/new',
    component:        BillingAlertsNew,
    private:          true,
    navNodes:         billingAlerts,
    sidebarPath:      '/cloud/',
    extra:            {name: 'title.new_billingAlert', service: 'publicCloud'},
    requiredServices: ['publicCloud']
},
{
    path:             '/infrastructure/resources',
    component:        InfrastructureResourcesRoute,
    private:          true,
    sidebarPath:      '/cloud/',
    extra:            {name: 'title.infrastructure', service: 'publicCloud'},
    navNodes:         infrastructure,
    refresh:          invalidateInfrastructureResources,
    requiredServices: ['publicCloud']
},
{
    path:             '/infrastructure/resources/:resourceId/show',
    component:        InfrastructureResourceShowRoute,
    private:          true,
    extra:            {name: 'title.resources', service: 'publicCloud'},
    sidebarPath:      '/cloud/',
    navNodes:         infrastructure,
    requiredServices: ['publicCloud']
},
// {
//     path:             '/infrastructure/reservations',
//     component:        InfrastructureReservationsRoute,
//     private:          true,
//     extra:            {name: 'title.reservations', service: 'publicCloud'},
//     sidebarPath:      '/cloud/',
//     navNodes:         infrastructure,
//     refresh:          invalidateAwsReservations,
//     requiredServices: ['publicCloud']
// },
{
    path:         '/p200/report',
    component:    P200Report,
    private:      true,
    extra:        {name: 'title.p200', service: 'reports'},
    navNodes:     cmdb,
    sidebarPath:  '/cmdb/global-chart',
    dateRequired: {
        section: 'p200',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateReportP200,
    requiredServices: ['reports']
},
{
    path:      '/my/profile',
    component: UserProfile,
    private:   true,
    extra:     {name: 'title.my_profile'},
    navNodes:  user
},
{
    path:      '/my/accounts',
    component: UserAccountsRoute,
    private:   true,
    extra:     {name: 'title.my_accounts'},
    navNodes:  user,
    refresh:   invalidateMyAccounts
},
{
    path:      '/my/accounts/:accountId/',
    component: UserAccountsEdit,
    private:   true,
    extra:     {name: 'title.edit_account'},
    navNodes:  user
},
{
    path:      '/my/credentials',
    component: UserCredentialsRoute,
    private:   true,
    extra:     {name: 'title.my_security_credentials'},
    navNodes:  user,
    refresh:   invalidateMyCredentials
},
{
    path:      '/my/credentials/new',
    component: CredentialsNewRoute,
    private:   true,
    extra:     {name: 'title.new_credential'},
    navNodes:  user
},
{
    path:      '/my/credentials/:credentialId',
    component: CredentialsEditRoute,
    private:   true,
    extra:     {name: 'title.edit_credential'},
    navNodes:  user
},
{
    // path:       '/azure-csp/refresh-token/',
    path:       '/sso-cloudglass/',
    component:  AzureRefreshToken,
    isExternal: true
},
{
    path:         '/cmdb/global-chart',
    component:    CMDBGlobalRoute,
    private:      true,
    extra:        {icon: 'cmdb-reports',name: 'title.cmdbReports', service: 'cmdb'},
    sidebarPath:  '/cmdb/global-chart',
    navNodes:     cmdb,
    dateRequired: {
        section: 'cmdb',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateCMDB,
    requiredServices: ['cmdb']
},
{
    path:         '/cmdb/details',
    component:    CMDBDetailsRoute,
    private:      true,
    extra:        {name: 'title.events', service: 'cmdb'},
    sidebarPath:  '/cmdb/global-chart',
    navNodes:     cmdb,
    dateRequired: {
        section: 'cmdb',
        types:   [PERIOD_TYPES.PERIOD_TYPE_MONTH]
    },
    refresh:          invalidateCMDB,
    requiredServices: ['cmdb']
},
{
    path:        '/external-portals/',
    component:   Portals,
    private:     true,
    sidebarPath: '/external-portals/',
    extra:       {icon: 'quick-links', name: 'label.quickLinks'},
    navNodes:    portals
},
{
    path:        '/customer-voice/',
    component:   CustomerVoice,
    private:     true,
    sidebarPath: '/customer-voice/',
    extra:       {icon: 'customer-voice', name: 'label.customerVoice'},
    navNodes:    customerVoice
}];

const _mocks = () => {
    if (SHOW_MOCKS && SHOW_MOCKS !== '0' && SHOW_MOCKS !== 'undefined') {
        return [
            {
                path:      '/jobplans/plans',
                component: Plans,
                private:   true,
                extra:     {icon: 'calendar', name: 'title.plans'},
                navNodes:  jobplans
            },
            {
                path:        '/jobplans/plans/new',
                component:   PlanNew,
                private:     true,
                sidebarPath: '/jobplans/plans',
                extra:       {name: 'title.plans_new'},
                navNodes:    jobplans
            },
            {
                path:      '/csc/contacts',
                component: Contacts,
                private:   true,
                extra:     {icon: 'address-book-o', name: 'title.contacts'},
                navNodes:  csc
            },
            {
                path:        '/csc/contacts/new',
                component:   ContactNew,
                private:     true,
                sidebarPath: '/csc/contacts',
                navNodes:    csc
            },
            {
                path:        '/csc/contacts/:contactId/show',
                component:   ContactShow,
                private:     true,
                sidebarPath: '/csc/contacts',
                navNodes:    csc
            },
            {
                path:        '/csc/contacts/:contactId/edit',
                component:   ContactEdit,
                private:     true,
                sidebarPath: '/csc/contacts',
                navNodes:    csc
            },
            {
                path:        '/backupsmocks',
                component:   BackupsMocks,
                private:     true,
                sidebarPath: '/backups',
                extra:       {icon: 'fackeDatabase', name: 'title.backups.mock'},
                navNodes:    backupsMocks
            }];
    }

    return [];
};

export default routes.concat(_mocks());



// WEBPACK FOOTER //
// ./src/config/routes.js